import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_SETTINGS = {
  company_name: "Zeke Industries LLC",
  tagline: "Steel Buildings & Erecting",
  hero_eyebrow: "Zeke Industries LLC — Pre-Engineered Metal Buildings & Erecting",
  hero_line_1: "WE RAISE",
  hero_line_2: "STEEL THAT",
  hero_line_3: "OUTLASTS.",
  hero_subtext:
    "From backyard shops to commercial builds, we supply and erect pre-engineered metal buildings that stand straight, seal tight, and outlast everything around them.",
  phone: "208-243-5808",
  email: "Zekeindustriesllc@gmail.com",
  address: "417 3rd Street, Rupert, ID 83350",
  hours: "Mon – Sat, 7am – 6pm",
  facebook_url: "https://www.facebook.com/zekeindustriesllc",
  instagram_url: "https://instagram.com/zekeindustriesllc",
  marquee_items:
    "Pre-Engineered Metal Buildings, Erecting Services, Residential Shop Builds, Commercial Builds, Barndominiums, Lean-Tos & Additions",
  logo_url: "",
};

export const assetUrl = (u) =>
  u && u.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;

const SettingsContext = createContext({ settings: DEFAULT_SETTINGS, refresh: () => {} });

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  const refresh = useCallback(() => {
    axios
      .get(`${API}/settings`)
      .then((r) => setSettings({ ...DEFAULT_SETTINGS, ...r.data }))
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};
